module.exports = __webpack_public_path__ + "static/media/path-29792.f86d9dae.svg";